// handles changing the relative sizes of the nav and display panes

import Backbone from 'backbone'

import _ from 'lodash'
import $ from 'jquery'
import mobile from 'scoreboard/components/mobile'
import isRtl from 'scoreboard/components/is-rtl'

var Resizer = Backbone.View.extend({

	className: 'resize-handle',

	events: {
		'mousedown': 'listen',
		'touchstart': 'listen'
	},

	initialize: function (opts) {
		this.container = opts.container
		this.grid = opts.grid
		this.minWidth = opts.minWidth
		this.secondaryMenuContainer = opts.secondaryMenuContainer
		// Default max 'width' for the resizer (50px from the right edge)
		this.maxWidth = opts.maxWidth || 50

		_.bindAll(this, 'drag', 'drop', 'setMaxWidth')
	},

	listen: function (e) {
		// Prevent cursor from changing to text cursor when dragging in Safari
		e.originalEvent.preventDefault()

		this.container.addClass('is-resizing')
		this.state = {
			width: this.container.width(),
			position: (e.pageX || e.originalEvent.touches[0].pageX)
		}

		$(document).on('mousemove touchmove', this.drag)
		$(document).on('mouseup touchend', this.drop)
	},

	drag: function (e) {
		// in case the mouse moves past the the edge of the resize element
		$('html, body').css('cursor', 'ew-resize')
		var diff = this.state.position - (e.pageX || e.originalEvent.touches[0].pageX)
		var width
		width = Math.max(0, this.state.width + (isRtl() ? diff : -diff))
		// The resizer shouldn't continue manipulating sizes if it's reached it's max width
		if (width >= $(window).width() - this.maxWidth) {
			return
		}
		if (this.grid) {
			this.container.width('100%')
			width = Math.max(width, this.minWidth)
			this.grid.css('grid-template-columns', `${width}px 1fr`)
		} else {
			this.container.width(width)
		}
		if(mobile.isMobileMenuVisible()) {
			// Although it looks like one menu to the user, the menu is someimes
			// made of independently sized parts. here we're taking one of the
			// other parts and setting it to be the same width as the rest of the
			// menu.
			if(this.secondaryMenuContainer) {
				this.secondaryMenuContainer.width(width)
			}
		}
		this.trigger('resize')
	},

	setMaxWidth: function(max) {
		this.maxWidth = max
	},

	drop: function (e) {
		$('html, body').css('cursor', '')
		this.container.removeClass('resizing')
		$(document).off('mousemove touchmove', this.drag)
		$(document).off('mouseup touchend', this.drop)
		this.trigger('stopResize')
	}

})

export default Resizer

Resizer.__filename__ = 'components/resizer.js'
